import React from "react";
import { Chip, Tooltip } from "@material-ui/core";

export function getMvrDetails(status, isMapped) {
    if (!isMapped) return { label: "Not registered", message: "", color: "#666", background: "#f3f3f3" };
    switch (status) {
        case "VERIFIED":
            return { label: "Verified", message: "Fund details verified.", color: "#2e7d32", background: "#e8f5e9" };
        case "PENDING":
            return { label: "Pending", message: "Fund verification is in progress (usually 24–48 hours). Payment is not ready yet.", color: "#9a5700", background: "#fff3e0" };
        case "REJECTED":
            return { label: "Rejected", message: "Fund details were rejected. Fix the details in the employee's Financial profile and update before payment.", color: "#c62828", background: "#fce4ec" };
        case "NOT_SUPPORTED":
            return { label: "Not supported", message: "This fund does not support member verification. Review the fund details before payment.", color: "#9a5700", background: "#fff3e0" };
        case "TIMED_OUT":
            return { label: "Timed out", message: "The fund did not respond. Update to retry before payment.", color: "#c62828", background: "#fce4ec" };
        case null:
        case undefined:
        case "":
            return { label: "Not reported", message: "No fund verification status has been reported for this employee.", color: "#666", background: "#f3f3f3" };
        default:
            return { label: status, message: "Fund verification status is not recognised. Check before paying.", color: "#666", background: "#f3f3f3" };
    }
}

export default function MvrStatus({ status, reason, isMapped }) {
    const details = getMvrDetails(status, isMapped);
    const hasReason = typeof reason === "string" && Boolean(reason.trim());
    const chip = (
        <Chip
            label={details.label}
            style={{ backgroundColor: details.background, color: details.color, fontWeight: 700, fontSize: 12, height: 26 }}
        />
    );
    return (
        <div>
            {details.message || hasReason ? (
                <Tooltip
                    title={
                        <div>
                            {details.message && <div>{details.message}</div>}
                            {hasReason && (
                                <div style={{ marginTop: details.message ? 8 : 0, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
                                    <strong>Reason: </strong>{reason}
                                </div>
                            )}
                        </div>
                    }
                    placement="top"
                    enterTouchDelay={0}
                    leaveTouchDelay={5000}
                >
                    <span tabIndex={0} aria-label={`Fund verification: ${details.label}`} style={{ display: "inline-flex", cursor: "help" }}>
                        {chip}
                    </span>
                </Tooltip>
            ) : chip}
        </div>
    );
}